import React, {FC} from 'react';
import styled from 'styled-components';

import {InboxModel} from '../../../../../../libs/shared/core/src/models/api/inboxModel';
import {inboxHasColor} from '../../../../../../libs/shared/core/src/models/helpers/inboxHelpers';
import {ColorDot} from '../../../../../../libs/shared/ui/src/components/utility/colorDot';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ConversationCardInboxProps {
  inbox: InboxModel;
}

/*
 * Styles.
 */

const StyledConvInbox = styled.div`
  ${flexCenter}
  margin-right: 8px;
`;

const StyledInboxName = styled.div`
  margin-left: 8px;
  line-height: 18px;
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const ConversationCardInbox: FC<ConversationCardInboxProps> = ({inbox}) => {
  const theme = useUserTheme();
  const color = inboxHasColor(inbox) ? inbox.color : theme.greys.shade50;

  return (
    <StyledConvInbox>
      <ColorDot color={color} size={8} />
      <StyledInboxName>{inbox.name}</StyledInboxName>
    </StyledConvInbox>
  );
};
